import type { IEnvFlagsDto } from "@ryde/shared";

export const ENV_FLAG_KEYS: (keyof IEnvFlagsDto)[] = [
  "isJenkinsEnv",
  "isJenkinsAutoEnv",
  "isRabbitTtlEnv",
  "isConsolePretty",
  "isLocalRun",
  "isTestEnv",
  "isDevEnv",
  "getAppLogLevels",
];
